import React from "react";
import Chip from "@mui/material/Chip";
import { datosEstado } from "./constantes";

// Estado del pedido como chip de color. Con onClick funciona como filtro (seleccionado = color del estado).
function ChipEstado({ idEstado, valor, cantidad, onClick, seleccionado, size = "small" }) {
  const estado = datosEstado(idEstado, valor);
  const filtro = typeof onClick === "function";
  const relleno = !filtro || seleccionado;

  return (
    <Chip
      size={size}
      onClick={onClick}
      label={cantidad !== undefined ? `${estado.nombre} · ${cantidad}` : estado.nombre}
      sx={{
        fontWeight: 600,
        maxWidth: "100%",
        color: relleno ? estado.color : "text.secondary",
        bgcolor: relleno ? estado.fondo : "#F2F3F4",
        "&:hover": filtro ? { bgcolor: estado.fondo } : undefined,
      }}
    />
  );
}

export default ChipEstado;
